const actions = {
  giftCardDesignApiName: 'GIFT_CARD_DESIGN_API',
  requestGiftCardDesign: 'giftCardDesign/request',
}

export default actions
